import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMarker = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 19.5q1.45 0 2.48-1.02Q19.5 17.45 19.5 16t-1.02-2.48Q17.45 12.5 16 12.5t-2.48 1.02Q12.5 14.55 12.5 16t1.02 2.48Q14.55 19.5 16 19.5zm0 16.55q6.65-6.05 9.82-10.97Q29 20.14 29 16.4q0-5.9-3.77-9.65T16 3q-5.45 0-9.22 3.75Q3 10.5 3 16.4q0 3.75 3.25 8.67Q9.5 30 16 36.05zM16 40Q7.95 33.15 3.97 27.28 0 21.4 0 16.4 0 8.9 4.82 4.45 9.65 0 16 0t11.18 4.45Q32 8.9 32 16.4q0 5-3.98 10.88T16 40zm0-23.6z" })
});
export default SvgMarker;
